import {
  Box,
  Grid,
  useMediaQuery,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Logo from "src/@core/components/logo";
import { useSettings } from "src/@core/hooks/useSettings";
// import LoginBanner from "src/assets/images/login-banner.png";
// import SignupBanner from 'src/assets/images/signup-banner.png'
import bannerImg from "../assets/images/createOrderImg.png";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LeftWrapper = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  // padding: '24px',
  display: "flex",
  padding: "20px",
}));

const LeftContainer = styled(Box)(({ theme }) => ({
  borderRadius: "24px",
  flex: "1",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  background: "#8C77B8",
  backgroundImage: `url(${bannerImg})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
}));

const LoginIllustrationWrapper = styled(Box)(({ theme }) => ({
  // marginTop: '125px',
  // padding: '25px',
  maxWidth: "400px",
  // alignItems: 'center'
}));

const RightWrapper = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  padding: { md: "20px" },
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  margin: "auto",
  [theme.breakpoints.up("md")]: {
    maxWidth: 550,
  },
}));

const AuthLayout = ({ children }) => {
  const theme = useTheme();
  const location = useLocation();
  const { i18n } = useTranslation();
  const { settings, saveSettings } = useSettings();

  // console.log("location", location.pathname);
  const hidden = useMediaQuery(theme.breakpoints.down("md"));

  const handleLanguageChange = (event) => {
    const nextLang = event.target.value;
    i18n.changeLanguage(nextLang);
    saveSettings({ ...settings, direction: nextLang === "ar" ? "rtl" : "ltr" });
  };

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: 20,
          right: 20,
          zIndex: 10,
        }}
      >
        <FormControl
          size="small"
          sx={{
            minWidth: "unset",
            backgroundColor: "rgba(255, 255, 255, 0.85)",
            borderRadius: "10px",
            backdropFilter: "blur(4px)",
            "& .MuiOutlinedInput-notchedOutline": {
              border: "2px solid #D33D4F !important",
              borderRadius: "10px",
            },
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.95)",
            },
          }}
        >
          <Select
            value={i18n.language}
            onChange={handleLanguageChange}
            sx={{
              color: "#D33D4F",
              fontWeight: 700,
              fontSize: "16px",
              "& .MuiSelect-select": {
                py: 1.5,
                px: 3,
                display: "flex",
                alignItems: "center",
              },
            }}
          >
            <MenuItem value="en">En</MenuItem>
            <MenuItem value="ar">Ar</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Grid container className="content-right">
        {!hidden ? (
          <Grid item xs={12} md={6} sx={{ flex: 1 }}>
            <LeftWrapper>
              <LeftContainer>
                <LoginIllustrationWrapper>
                  {/* <Logo width={'100%'} /> */}
                </LoginIllustrationWrapper>
              </LeftContainer>
            </LeftWrapper>
          </Grid>
        ) : (
          <></>
        )}
        <Grid item xs={12} md={6}>
          <Box className="content-center">
            <RightWrapper>
              {hidden && (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  marginBottom="2.5rem"
                  marginTop="2.5rem"
                >
                  <Logo />
                </Box>
              )}
              {children}
            </RightWrapper>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default AuthLayout;
